import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FaIconSharedModule } from './../fa.icon/fa.icon.module';
import { TextButtonSharedComponent } from './text.button.component';

@NgModule({
    declarations: [
        TextButtonSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        TextButtonSharedComponent
    ]
})

export class TextButtonSharedModule {}
